import useGetProductAddressData from './useGetProductAddressData'

export default useGetProductAddressData
